
export class Item {

    constructor(
        public name: string,
        public description: string,
        public category = 'product',
        public tags = [],
        public item_picture?: string,
        public lat?: number,
        public long?: number,
        public cdate?: string,
        public itemId?: string,
        public video_url?: string,
        public stream_url?: string,
        public clickMe?: string,
        public finishDate?: string,
        public startdate?: string,
        public address?: string,
        public section?: string,
        public original_url?: string,
        public isMembersOnly?: boolean,
        public isGoldPlan?: boolean,
    ) { }

}
